<button
  [type]="type"
  [id]="id"
  [disabled]="disabled"
  class="gts-btn"
  [class.disabled]="disabled"
  [class.fullWidth]="fullWidth"
  (click)="handleClick($event)"
  [routerLink]="routerLink"
  [ngClass]="{
    'gts-btn-primary-outline': outline,
    'gts-btn-primary': primary && !outline,
    'gts-btn-outline-danger': outlineDanger,
    'gts-btn-danger': danger,
    'gts-btn-danger-text': dangerText,
    'gts-btn-warning': warning,
    'gts-btn-outline-small': outlineSmall,
    'gts-btn-icon-only': iconOnly,
    'gts-btn-success': success,
    'gts-btn-info': info,
    'gts-btn-info-chip': infoChip,
    'gts-btn-main-gray': outlineMainGray,
  }"
>
  <!-- ICON LEFT -->
  <span
    *ngIf="iconLeftImg || iconLeftCustom || iconLeft || iconOnly"
    [ngClass]="{
      'gts-btn-icon-left': !iconOnly,
      'gts-btn-icon-only': iconOnly,
    }"
  >
    <img
      *ngIf="iconLeftImg"
      [src]="iconLeftImg"
      alt=""
      class="gts-btn-icon-img"
    />
    <app-icon
      *ngIf="iconLeftCustom || iconOnlyName"
      [name]="iconLeftCustom"
      alt=""
      [ngClass]="{
        primary: outline,
        danger: outlineDanger,
        white: primary || danger || warning || success || info,
        'main-gray': outlineMainGray,
        'danger-text': dangerText,
      }"
    >
    </app-icon>

    <ng-container *ngIf="!iconLeftImg && !iconLeftCustom">
      {{ iconLeft }}
    </ng-container>
  </span>

  <!-- TEXT -->
  <span
    *ngIf="label"
    class="gts-btn-text"
    [ngClass]="{ borderRight: borderRight }"
    >{{ label }}</span
  >

  <!-- ICON RIGHT -->
  <span
    *ngIf="iconRight || iconRightImg || iconRightCustom"
    class="gts-btn-icon-right"
  >
    <img
      *ngIf="iconRightImg"
      [src]="iconRightImg"
      alt=""
      class="gts-btn-icon-img"
    />
    <app-icon
      *ngIf="!iconRightImg && iconRightCustom"
      [name]="iconRightCustom"
      alt=""
      [ngClass]="{
        primary: outline,
        danger: outlineDanger,
        white: primary || danger || warning,
      }"
    >
    </app-icon>
    <ng-container *ngIf="!iconRightImg && !iconRightCustom">
      {{ iconRight }}
    </ng-container>
  </span>
</button>
